module.exports = __webpack_public_path__ + "img/case-hero--boconcept.664e03e4.jpg";